// v10/src/utils/planFeatures.js
// Helper para chequear features del plan del usuario actual.
// El backend (/auth/me) devuelve user.effective_features con
// defaults del plan + overrides manuales ya aplicados.

export function hasFeature(user, featureKey) {
  if (!user || !user.effective_features) return false;
  return user.effective_features[featureKey] === true;
}

export function getLimit(user, limitKey) {
  if (!user || !user.effective_features) return null;
  const v = user.effective_features[limitKey];
  return v === undefined ? null : v;
}
